export const outdoorPath = '/outdoor-collection';
export const outdoorPathDetail = '/outdoor-collection/:id';


